import { atom } from 'recoil';

const showSelectLanguageState = atom({
  key: 'showSelectLanguageState',
  default: false,
});

export default showSelectLanguageState;
